import makeMapper from '../mappers/string-to-object'

const mapper = makeMapper(['value', 'label'])

const collections_browsers = {
	key: 'collections.browsers',

	fn() {
		return {
			normalizer(data) {
				return data.map(mapper)
			},
		}
	},
}

export { collections_browsers as default }
